<!--
 * @Author: your name
 * @Date: 2020-12-11 17:42:05
 * @LastEditTime: 2021-02-06 14:16:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/global/Notify/index.vue
-->
<style lang="sass" scoped>
.msg
  text-align: left

.icon
  align-self: flex-start
  width: 20px
  height: 20px
</style>

<style lang="sass" scoped>
::v-deep
  .van-icon::before
    font-size: 20px

</style>

<template lang="pug">
div(v-if="visible")
  van-notify(v-model="visible" :type="type")
    van-icon.icon(:name="icon" style="margin-right: 4px;")
    span.msg {{ message }}
</template>

<script>
import resizeHandler from 'utils/resizeHandler'
export default {
  name: 'Notify',

  mixins: [resizeHandler],

  props: {
    type: {
      type: String, // success, danger
      default: 'success',
    },
    message: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      default: 3000,
    }
  },

  computed: {
    icon() {
      if (this.type === 'success') {
        return 'checked'
      }
      return 'warning'
    }
  },

  data() {
    return {
      visible: false,
    }
  },

  created() {
    this.timer = null
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },

  methods: {
    show() {
      if (this.timer) clearInterval(this.timer)
      this.visible = true
      this.timer = setTimeout(_ => {
        this.close()
      }, this.duration)
    },

    close() {
      this.visible = false
      if (this.timer) clearInterval(this.timer)
    }
  },
}
</script>
